module.exports = __webpack_public_path__ + "img/1f382.ab4c8c7.svg";